import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
const BASE = BaseModel.getApiBasePath() + '/api/v1/core/parkinglocations';

export default new class ParkinglocationModel {

  get(id) {
    return new Promise((resolve, reject) => {
      this.getAll()
        .then((data) => {
          resolve(_.find(data, {id: id}));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAll(force = false) {    
      return new Promise((resolve, reject) => {
        if (!localStorage.getItem('dataset_parkinglocations') || force) {
          axios.get(BASE, {
            params: {
              access_token: UserModel.getAccessToken()
            }
          })
          .then((response) => {
            localStorage.setItem('dataset_parkinglocations', JSON.stringify(response.data));
            resolve(response.data);          
          })
          .catch((error) => {
            reject(error);
          });
        } else {
          resolve(JSON.parse(localStorage.getItem('dataset_parkinglocations'))); 
        }
      });    
  }

  create(data) {
    return new Promise((resolve, reject) => {
      axios.post(BASE, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
      .then((response) => {        
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

  patch(id, data) {
    return new Promise((resolve, reject) => {
      axios.patch(BASE + '/' + id, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
      .then((response) => {        
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

  remove(id) {
    return new Promise((resolve, reject) => {
      axios.delete(BASE + '/' + id, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
      .then((response) => {        
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

}


// WEBPACK FOOTER //
// ./src/components/ParkinglocationModel.js